import { useState, useEffect, useRef } from 'react';
import { rmContentService } from '../services';
import type { RmContentDocument } from '../types/rmContent';

interface UseRmContentReturn {
  content: RmContentDocument | null;
  isLoading: boolean;
  isRmContent: boolean;
}

export const useRmContent = (url: string, enabled: boolean, language?: string): UseRmContentReturn => {
  const [content, setContent] = useState<RmContentDocument | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isRmContent, setIsRmContent] = useState(false);
  const lastUrlRef = useRef('');

  useEffect(() => {
    if (!enabled || !url) {
      setContent(null);
      setIsLoading(false);
      setIsRmContent(false);
      lastUrlRef.current = '';
      return;
    }

    // Avoid re-fetching the same URL
    if (url === lastUrlRef.current) return;
    lastUrlRef.current = url;

    let cancelled = false;
    setIsLoading(true);

    rmContentService.getContentByUrl(url, language)
      .then((doc) => {
        if (cancelled) return;
        setContent(doc);
        setIsRmContent(true);
        setIsLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setContent(null);
        setIsRmContent(false);
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [url, enabled, language]);

  return { content, isLoading, isRmContent };
};
